/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Why reading an MCP server address produced nothing.
 */
export enum McpServerLookupFailure {
    INVALID_URL = 'invalid_url',
    UNREACHABLE = 'unreachable',
    TLS_FAILED = 'tls_failed',
    TIMED_OUT = 'timed_out',
    NOT_PROTECTED = 'not_protected',
    NO_OAUTH_METADATA = 'no_oauth_metadata',
    MALFORMED_METADATA = 'malformed_metadata',
    RATE_LIMITED = 'rate_limited',
    SERVER_ERROR = 'server_error',
}
